import React from 'react'
import arrayMove from 'array-move'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import Icon from '../../../ui/Icon/Icon'
import RelatedProductSearch from '../UtmBuilder/RelatedProductSearch'
import './AmeCampaignProductMultiSelect.sass'

const OrderDragHandle = SortableHandle(() => (
  <span
    className="AmeCampaignProductMultiSelect-OrderHandle"
    title="Перетягнути"
    role="button"
    tabIndex={-1}
    aria-label="Змінити порядок"
    onClick={(event) => event.stopPropagation()}
  >
    <i />
    <i />
    <i />
    <i />
    <i />
    <i />
  </span>
))

const OrderItem = SortableElement(({ item, indexLabel, onRemove }) => (
  <div className="AmeCampaignProductMultiSelect-OrderItem">
    <OrderDragHandle />
    <span className="AmeCampaignProductMultiSelect-OrderIndex">{indexLabel}</span>
    <span className="AmeCampaignProductMultiSelect-OrderLabel" title={item.name || item.productId}>
      {item.name || item.productId}
      <span className="AmeCampaignProductMultiSelect-OrderMeta">
        {item.catalog === 'outlet' ? 'Outlet' : 'Premium'}
      </span>
    </span>
    <button
      type="button"
      className="AmeCampaignProductMultiSelect-OrderBtn AmeCampaignProductMultiSelect-OrderBtnDanger"
      title="Прибрати"
      onClick={(event) => {
        event.stopPropagation()
        onRemove(item)
      }}
    >
      <Icon name="times" weight="regular" size={12} />
    </button>
  </div>
))

const OrderList = SortableContainer(({ items, onRemove }) => (
  <div className="AmeCampaignProductMultiSelect-OrderList">
    {items.map((item, index) => (
      <OrderItem
        key={`${item.catalog}:${item.productId}`}
        index={index}
        indexLabel={index + 1}
        item={item}
        onRemove={onRemove}
      />
    ))}
  </div>
))

function AmeCampaignProductMultiSelect({
  value = [],
  onChange,
  searchIndex = [],
  filters,
  isLoading,
  loadError,
  onLoadRequest,
  canBrowseOnFocus = false,
  reorderable = false,
  label = 'Товари',
  buttonPicker = false,
}) {
  const selectedKeys = new Set(value.map((item) => `${item.catalog}:${item.productId}`))

  const handlePick = (product) => {
    if (!product?.id) return
    const catalog = product.source === 'outlet' ? 'outlet' : 'premium'
    const key = `${catalog}:${product.id}`
    if (selectedKeys.has(key)) return
    onChange([
      ...value,
      {
        catalog,
        productId: product.id,
        name: product.name || '',
        brandName: product.brandName || '',
        avatarFileName: product.avatarFileName || null,
        price: product.price != null ? product.price : null,
        descriptionShort: product.descriptionShort || '',
        remainQuantity: product.remainQuantity != null ? product.remainQuantity : null,
      },
    ])
  }

  const handleRemove = (item) => {
    onChange(value.filter((entry) => !(entry.catalog === item.catalog && entry.productId === item.productId)))
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return
    onChange(arrayMove(value, oldIndex, newIndex))
  }

  const picker = (
    <RelatedProductSearch
      value={null}
      onChange={handlePick}
      searchIndex={
        buttonPicker
          ? searchIndex.filter((product) => !selectedKeys.has(`${product.source}:${product.id}`))
          : searchIndex
      }
      filters={filters}
      isLoading={isLoading}
      loadError={loadError}
      onLoadRequest={onLoadRequest}
      canBrowseOnFocus={canBrowseOnFocus}
      label={buttonPicker && value.length ? 'Додати ще товар' : label}
      buttonPicker={buttonPicker}
    />
  )

  return (
    <div className={buttonPicker ? 'AmeCampaignProductMultiSelect_button' : undefined}>
      {!buttonPicker ? picker : null}
      {value.length > 0 ? (
        reorderable ? (
          <OrderList
            items={value}
            onRemove={handleRemove}
            axis="y"
            lockAxis="y"
            useDragHandle
            helperClass="AmeCampaignProductMultiSelect-OrderItemDragging"
            distance={4}
            onSortEnd={onSortEnd}
          />
        ) : (
          <div className="UtmBuilder-RelatedBrandsChips" style={{ marginTop: 8 }}>
            {value.map((item) => (
              <span key={`${item.catalog}:${item.productId}`} className="UtmBuilder-RelatedBrandsChip">
                <span className="UtmBuilder-RelatedBrandsChipLabel">
                  {item.name || item.productId}
                  {item.catalog === 'outlet' ? ' · Outlet' : ' · Premium'}
                </span>
                <button
                  type="button"
                  className="UtmBuilder-RelatedBrandsChipRemove"
                  title="Прибрати товар"
                  onClick={() => handleRemove(item)}
                >
                  <Icon name="times" weight="regular" size={12} />
                </button>
              </span>
            ))}
          </div>
        )
      ) : null}
      {buttonPicker ? picker : null}
    </div>
  )
}

export default AmeCampaignProductMultiSelect
